import React, { useEffect, useState } from "react";
import { Button } from "semantic-ui-react";
import { useSelector } from "react-redux";
import ExpandCollapseButton from "./expandCollapseButton";
import BackToPoolButton from "./backToPoolButton";
import TakeOverButton from "./takeOverButton";
import ReviewEntryButton from "./reviewEntry";
import FileEntryButton from "./fileEntry";
import UpdateEntry from "./updateEntry";
import UnHoldShipmentButton from "./unHoldShipmentButton";
import HoldShipmentButton from "./holdShipmentButton";
import NLUpdateResponseEntry from "./NLUpdateResponseEntry";
import { getEntryStateChecks, getJobStates, getJobWheels } from "../../components/util";
import { selectHeaderTabDS } from "@EUForms/selectors";
import { selectFileFormType } from "../../components/DMS_App/selectors";
import FileEmergencyProcedure from "../../components/DMS_App/formSections/header/fileEmergencyProcedure";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";


function NLDMSButtonMapper(props) {
    const {
        shipId: shipmentId,
        serviceType,
        lowerEnv,
        searchByID,
        currentJobData,
        kxUser: {
            userBasicInfo: {
                userGuid
            } = {}
        } = {},
    } = props

    const brokerGuid = currentJobData?.brokerGuid
    const mrn = currentJobData?.mrn
    const ducr = currentJobData?.ducr

    const jobWheels = getJobWheels(currentJobData);
    const getJobWheel = getJobStates(jobWheels)
    const entryState = getJobWheel('ES_ENTRY_JOB_WHEEL')
    const customState = getJobWheel('NL_CUSTOM_JOB_WHEEL')
    const bhHouse = getJobWheel('SHIPMENT_BROKER_HOUSE_PROCESS');
    const isBHInProcess = bhHouse === "STATE_BH_BROKER_IN_PROCESS"
    const isBHAssigned = (bhHouse === 'STATE_BH_ASSIGNED' || bhHouse === 'STATE_BH_BROKER_ASSIGNED')
    const isLowerEnv = (lowerEnv[0] !== 'prod');
    const { childShipments } = useSelector(selectHeaderTabDS)
    const {shipmentId:shipmentIdFromProvider} = useCurrentShipmentType()
    const {
        isEntryOrCustomStateNone,
        // isEntryNewJob,
        isEntryEditable,
        isEntryInProcess,
        isEntryFileReady,
        isEntryReady,
        isEntryFiled,
        isEntryCancelFiled,
        isEntryCancelFailed,
        isSupFiled,
        isSupAccepted,
        isExtFiled,
        isExtAccepted,
        isExtRejected,
        isSupRejected,
        isEntryOnHold,
        isEntryRejected,
        isEntryAccepted,
        // isEntryCompleted,
        isEntryReleased,
        isEntryAmendInProcess,
        isEntryAmendFileReady,
        isEntryAmendFiled,
        isCancelledFiled,
        isCancelAccepted,
        // isCancelledFailed,
        isEntryAmendFailed,
        isEntryAmendRejected,
        isEntryAmendAccepted,
        isRFIRejected
    } = getEntryStateChecks(entryState, customState)

    const { procedure, declType, transmissionType } = useSelector(selectHeaderTabDS)
    // console.log("headerTab_props____", procedure, declType, transmissionType)
    const [reviewedSuccessfully, setReviewSuccessfully] = useState(false);

    useEffect(() => {
        setReviewSuccessfully(false)
    }, [shipmentId])

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            buildButtons()
        }, 5000)
        return () => clearTimeout(timeoutId);
    }, [JSON.stringify(currentJobData), shipmentId])

    const fileFormType = selectFileFormType({ procedure, declType, transmissionType, serviceType })

    const setReviewedSuccess = () => setReviewSuccessfully(true)

    const bhAssignedButtons = [
        {
            component: UnHoldShipmentButton,
            conditions: [isBHAssigned, isEntryOnHold, userGuid === brokerGuid],
            extraProps: {},
            return: true
        },
        {
            component: TakeOverButton,
            conditions: [isBHAssigned, isEntryOnHold, userGuid !== brokerGuid],
            extraProps: {
                currentEntryState: entryState,
                NLCustomState: customState
            },
            return: true
        }
    ]

    const bhInProcesButtons = [
        {
            component: TakeOverButton,
            conditions: [isBHInProcess, userGuid !== brokerGuid, (isEntryEditable || isEntryOnHold)],
            extraProps: {
                currentEntryState: entryState,
                NLCustomState: customState
            },
            return: true,
        },
        {
            component: BackToPoolButton,
            conditions: [isBHInProcess, userGuid === brokerGuid, (isEntryInProcess || isEntryFileReady)],
            extraProps: {},
            return: false
        },
        {
            component: UnHoldShipmentButton,
            conditions: [isBHInProcess, isEntryOnHold, userGuid === brokerGuid],
            extraProps: {},
            return: true
        },
        {
            component: HoldShipmentButton,
            conditions: [isBHInProcess, isEntryEditable, (isEntryReady || isEntryInProcess), userGuid === brokerGuid, !reviewedSuccessfully],
            extraProps: {},
            return: false
        },
        {
            component: ReviewEntryButton,
            conditions: [isBHInProcess, isEntryEditable, !isEntryOrCustomStateNone, !reviewedSuccessfully],
            extraProps: {
                setReviewSuccessfully: setReviewedSuccess,
                currentEntryState: entryState,
                transmissionType:transmissionType,
                formType: fileFormType,
                shipId: entryState?.includes('RFI') ?
                    shipmentIdFromProvider?.includes('-C-') ? shipmentIdFromProvider : childShipments?.at(-1)
                    : shipmentId
            },
            return: false
        },
        {
            component: FileEntryButtonCustomized,
            conditions: [((isBHInProcess&&isEntryEditable&&isEntryFileReady && reviewedSuccessfully) || (transmissionType==="EMERGENCY"&&reviewedSuccessfully))],
            extraProps: {
                label: 'DMS',
                buttonLabel: fileFormType === 'IE583' ? 'EXT' : '',                
                transmissionType:transmissionType,
                formType: fileFormType,
                entryState:entryState,
                customState:customState
            },
            return: false
        },
        {
            component: UpdateEntrySubProcess,
            conditions: [
                isBHInProcess, !['STATE_DMS_599EOG'].includes(customState),
                (isEntryCancelFiled || isEntryRejected || isEntryAmendRejected || isEntryAmendFailed || isRFIRejected || isSupRejected || isExtRejected || isEntryAccepted || isEntryAmendAccepted || isEntryReleased)
            ],
            extraProps: {
                isEntryRejected: isEntryRejected,
                isEntryAmendRejected: isEntryAmendRejected,
                isEntryCancelFailed: isEntryCancelFailed,
                isRFIRejected: isRFIRejected,
                transmissionType: transmissionType,
                EntryState: entryState
            },
            return: false
        },
        {
            component: () => <div id="sendArrival-notice-button"></div>,
            conditions: [
                isBHInProcess, !['STATE_DMS_599EOG'].includes(customState),
                (isEntryCancelFiled || isEntryRejected || isEntryAmendRejected || isEntryAmendFailed || isRFIRejected || isSupRejected || isExtRejected || isEntryAccepted || isEntryAmendAccepted || isEntryReleased), !isEntryRejected, !isEntryAmendRejected
            ],
            extraProps: {},
            return: false
        },
        {
            component: UpdateEntry,
            conditions: [isBHInProcess, (isEntryAmendInProcess || isEntryAmendFileReady)],
            extraProps: {
                label: 'CANCEL AMEND',
                transmissionType: transmissionType,
                EntryState: entryState
            },
            return: false
        },
        {
            component: UpdateEntry,
            conditions: [isBHInProcess, (isEntryFiled || isSupFiled || isEntryAmendFiled || isCancelledFiled)],
            extraProps: {
                label: 'RESET',
                transmissionType: transmissionType,
                EntryState: entryState
            }, 
            return: false
        },
        {
            // isEntryAccepted removed as per 28191
            component: NLUpdateResponseEntryWithXMLButton,
            conditions: [isBHInProcess, isLowerEnv, (isEntryFiled || isEntryAmendFiled || isSupFiled || isExtFiled || isExtAccepted || isSupAccepted || isEntryAmendRejected || isSupRejected || isExtRejected || isCancelledFiled || isEntryAmendAccepted || isEntryReleased)],
            extraProps: {
                propMRN: mrn,
                propDUCR: ducr,
                formType: fileFormType,
                shipmentId: shipmentId,
                ESCustomState: customState,
                serviceType: serviceType,
                transmissionType: transmissionType,
                buttonTitle: "UPDATE RESPONSE",
            },
            return: false
        },
        {
            component: () => <div style={{ fontSize: '13px', color: 'crimson' }}>
                <strong>Note: </strong>No Action can be performed after Cancellation
                Accepted.
            </div>,
            conditions: [isBHInProcess, isCancelAccepted],
            extraProps: {},
            return: false
        },
    ]


    const optimizedWorkflowButtons = (buttonsArray) => {
        const buttons = [];
        for (let i = 0; i < buttonsArray.length; i++) {
            if (buttonsArray[i]?.conditions.every(condition => condition)) {
                buttons.push(buttonsArray[i]);
                if (buttonsArray[i]?.return) {
                    return buttons;
                }
            }
        }
        return buttons;
    }

    const buildButtons = () => {
        if (isBHAssigned) {
            return optimizedWorkflowButtons(bhAssignedButtons)
        } else if (isBHInProcess) {
            return optimizedWorkflowButtons(bhInProcesButtons)
        }
        return []
    }

    const workflowButtons = buildButtons() || []

    return (
        <div className="ace header-container dv-todo-isfheader">
            <ExpandCollapseButton {...props} />
            {window.typeOfUser !== "BROKER_KN_ADMIN" &&
                workflowButtons.map(({ component: Component, extraProps }, index) => {
                    return <Component key={index} {...props} {...extraProps} />
                })}
        </div>
    );
}

export const FileEntryButtonCustomized = (props) => {
    if(props?.transmissionType==='EMERGENCY'){
        return <FileEmergencyProcedure {...props} />
    }
    return <FileEntryButton {...props} />
}

export const NLUpdateResponseEntryWithXMLButton = ({ shipmentId, ...props }) => {
    return (
        <>
            <Button
                size="mini"
                key="XMLSENT"
                disabled={false}
                className="sv todo-button secondaryBtn"
                onClick={() => {
                    window.open(`broker-panel/xml-sent/nl/${shipmentId}`, '_blank')
                }}
            >
                VIEW XML SENT
            </Button>
            <NLUpdateResponseEntry
                shipmentId={shipmentId}
                {...props}
            />
        </>
    )
}

export const UpdateEntrySubProcess = ({ transmissionType, ...props }) => {
    const {
        isEntryRejected,
        isEntryAmendRejected,
        isEntryCancelFailed,
        isRFIRejected,
        ...restProps
    } = props
    let _label = (isEntryRejected || isEntryAmendRejected || isEntryCancelFailed || isRFIRejected) ? "UPDATE" : null
    let label = {
        "COR": 'AMEND',
        "SUP": 'SUPPLIMENTARY'
    }[transmissionType] || _label;

    return (transmissionType && label) ? <UpdateEntry
        {...restProps}
        label={label}
    /> : null
}

export default NLDMSButtonMapper;